import React from "react"
import { Grid, Box } from "@mui/material"
import { ProductVariantAsset } from "@secureo/common/typings/Product"
import YoutubeVideo from "components/YoutubeVideo"

import Icon from "@mdi/react"
import { mdiFileDownload } from "@mdi/js"

const isYoutubeVideoAsset = (asset: ProductVariantAsset) => {
	return asset.url.includes("youtu.be") || asset.url.includes("youtube.com")
}

const getYoutubeVideoIdFromUrl = (url: string) => {
	return url.split("/")?.reverse()?.[0] ?? null
}

const Assets = ({ assets }: Props) => {
	const youtubeVideoAssets = assets.filter(isYoutubeVideoAsset)
	const downloadAssets = assets.filter((asset) => !isYoutubeVideoAsset(asset))

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Grid container spacing={1}>
					{downloadAssets.map((asset, i) => {
						const { name, url } = asset

						return (
							<Grid item xs={12} sm={6} key={`${url}-${i}`}>
								<a
									href={url}
									target="__blank"
									style={{
										display: "flex",
										alignItems: "center",
										color: "#263739",
									}}
								>
									<Icon path={mdiFileDownload} size={1} color="#4691CE" />
									<Box ml={1}>{name}</Box>
								</a>
							</Grid>
						)
					})}
				</Grid>
			</Grid>

			{youtubeVideoAssets.map((asset) => {
				const { url } = asset
				const videoId = getYoutubeVideoIdFromUrl(url)

				return (
					<Grid item xs={12} md={6} key={url}>
						<YoutubeVideo videoId={videoId} />
					</Grid>
				)
			})}
		</Grid>
	)
}

interface Props {
	assets: ProductVariantAsset[]
}

export default Assets
